import { makeAutoObservable, runInAction } from 'mobx';

export class MenuStore {
  menu_data = {};
  is_loading = false;
  has_error = false;
  error_message = '';

  constructor(rootStore) {
    this.rootStore = rootStore;
    this.api = rootStore.api.menus;

    makeAutoObservable(this, {
      rootStore: false,
      api: false,
    });
  }

  get thisWebsiteMenu() {
    console.log(this.menu_data)
    return this.menu_data['owace-this-website-menu'] || null;
  }

  get quickLinksMenu() {
    return this.menu_data['owace-quick-links-menu'] || null;
  }

  fetchMenus = async () => {
    this.is_loading = true;
    this.has_error = false;
    this.error_message = '';

    try {
      const menuData = await this.api.list();

      runInAction(() => {
        this.menu_data = menuData;
        this.is_loading = false;
      });
    } catch (error) {
      runInAction(() => {
        this.has_error = true;
        this.error_message = error.message;
        this.is_loading = false;
      });
    }
  };
}

export default MenuStore;
